import VlogThumbnailPreview from "../Previews/Ship/ThumbnailPreview/VlogPreview";

export const vlogDetails = {
  form: [],
  component: [
    {
      type: 1,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required:"true",
          placeholder: "Max. 40 characters",
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          placeholder: "Max. 40 characters",
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          placeholder: "Max. 40 characters",
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          placeholder: "Max. 40 characters",
        },
        {
          title: "English Thumbnail Image",
          key: "image",
          className: "col-lg-3",
          type: "file",
          placeholder: "Upload English Thumbnail Image With a Height of 1280 and a Width of 720",
          required:"true"
        },
        {
          title: "Simplified Chinese Thumbnail Image",
          key: "simplified_chinese_image",
          className: "col-lg-3",
          type: "file",
          placeholder: "Upload Simplified Chinese Thumbnail Image With a Height of 1280 and a Width of 720",
        },
        {
          title: "Traditional Chinese Thumbnail Image",
          key: "traditional_chinese_image",
          className: "col-lg-3",
          type: "file",
          placeholder: "Upload Traditional Chinese Thumbnail Image With a Height of 1280 and a Width of 720",
        },
        {
          title: "Bahasa Thumbnail Image",
          key: "bahasa_image",
          className: "col-lg-3",
          type: "file",
          placeholder: "Upload Bahasa Thumbnail Image With a Height of 1280 and a Width of 720",
        },
        {
          title: "English Thumbnail Image Alt",
          key: "image_alt",
          className: "col-lg-3",
          type: "input",
          conditionalRequired: "image",
        },
        {
          title: "Simplified Chinese Thumbnail Image Alt",
          key: "simplified_chinese_image_alt",
          className: "col-lg-3",
          type: "input",
          conditionalRequired: "simplified_chinese_image",
        },
        {
          title: "Traditional Chinese Thumbnail Image Alt",
          key: "traditional_chinese_image_alt",
          className: "col-lg-3",
          type: "input",
          conditionalRequired: "traditional_chinese_image",
        },
        {
          title: "Bahasa Thumbnail Image Alt",
          key: "bahasa_image_alt",
          className: "col-lg-3",
          type: "input",
          conditionalRequired: "bahasa_image",
        },
        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "textarea",
          required:"true",
          placeholder: "Max. 250 characters",
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "textarea",
          placeholder: "Max. 250 characters",
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "textarea",
          placeholder: "Max. 250 characters",
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "textarea",
          placeholder: "Max. 250 characters",
        },
        {
          title: "English Video URL",
          key: "video_url",
          className: "col-lg-3",
          type: "input",
          inputType: "url",
          required:"true"
        },
        {
          title: "Simplified Chinese Video URL",
          key: "simplified_chinese_video_url",
          className: "col-lg-3",
          type: "input",
          inputType: "url",
        },
        {
          title: "Traditional Chinese Video URL",
          key: "traditional_chinese_video_url",
          className: "col-lg-3",
          type: "input",
          inputType: "url",
        },
        {
          title: "Bahasa Video URL",
          key: "bahasa_video_url",
          className: "col-lg-3",
          type: "input",
          inputType: "url",
        },
      ],
      preview: (activetab, cardData, rootData) => (
        <VlogThumbnailPreview activetab={activetab} cardData={cardData} rootData={rootData} />
      ),
    },
  ],
};
